import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { FontIconName, Icon } from "../Icon/Icon";
import styles from "./MediaPlaceholder.module.less";

export type MediaPlaceholderSize =
	| "extra-small"
	| "small"
	| "medium"
	| "large"
	| "extra-large";

export type MediaPlaceholderProps = {
	icon: FontIconName;
	size?: MediaPlaceholderSize;
	trackingId?: string;
};

export const MediaPlaceholder = (props: MediaPlaceholderProps): ReactElement => {
	const {
		icon,
		size = "small",
		trackingId
	} = props;

	const shouldRenderBox: boolean = size === "extra-large"
		|| size === "large";

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div
				className={classNames(
					styles.icon,
					buttonSizeToStylesMap[size],
					{
						[styles.icon_box]: shouldRenderBox
					}
				)}
			>
				<div className={styles.icon_backBox} />
				<div className={styles.icon_container}>
					<Icon
						value={{
							kind: "font",
							name: icon
						}}
					/>
				</div>
			</div>
		</div>
	);
};
MediaPlaceholder.displayName = "MediaPlaceholder";

const buttonSizeToStylesMap: { [key in MediaPlaceholderSize]: string | null } = {
	"extra-small": styles.icon_extraSmall,
	"small": null,
	"medium": styles.icon_medium,
	"large": styles.icon_large,
	"extra-large": styles.icon_extraLarge
};